import { IDisclaimerApprovalSaveResponse, IDisclaimerResponse } from '../interfaces/disclaimer-message.interface';

export const DISCLAIMER_RESPONSE: IDisclaimerResponse = {
    isApproved: false,
    clauses: [
        'I am not a financial adviser. I am not an accountant. \
        I\'m just a little old lady with a computer and an Internet connection.',
        'No part of this site\'s content should be construed as advice, and you should not take anything that is said here as investment \
        or financial advice.',
        'Speak with a professional before making important decisions about your money, your professional life, or your personal life.',
    ],
};

export const DISCLAIMER_APPROVAL_SAVE_RESPONSE: IDisclaimerApprovalSaveResponse = {
    isAccepted: true,
    reason: '',
};
